export default "__VITE_ASSET__56394c1e__"